var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYotpoSeeklogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 26 24",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.998155,
    cy: 12.126307,
    fill: "#000",
    rx: 12.169118,
    ry: 11.879877
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(5.498155 6.907523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.18421053.03647215h1.4368421l1.10526316 2.00596817 1.06842105-2.00596817h1.3631579l-1.80526316 3.20954907v1.71419098h-1.32631579v-1.67771883z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.75263158 2.51657825c0-1.49535809 1.21578947-2.51657825 2.61578947-2.51657825s2.61578948 1.05769231 2.61578948 2.51657825c0 1.49535809-1.21578948 2.5530504-2.61578948 2.5530504-1.4-.03647215-2.61578947-1.05769231-2.61578947-2.5530504m3.86842105 0c0-.76591512-.47894737-1.38594165-1.28947368-1.38594165-.81052632 0-1.28947369.62002653-1.28947369 1.38594165s.47894737 1.38594164 1.28947369 1.38594164c.84736842 0 1.28947368-.62002652 1.28947368-1.38594164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.2 1.1306366h-1.28947368v-1.09416445h3.90526318v1.09416445h-1.2894737v3.8295756h-1.3263158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.87894737 10.3580902h-1.28947369v-4.92374007h1.84210527c1.32631579 0 2.06315789.83885942 2.06315789 1.93302388 0 1.09416445-.7368421 1.93302387-2.06315789 1.93302387h-.55263158zm.47894737-2.18832893c.58947368 0 .81052631-.32824933.81052631-.80238726 0-.47413794-.22105263-.83885942-.81052631-.83885942h-.47894737v1.64124668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.71578947 7.91445623c0-1.49535809 1.21578948-2.51657825 2.61578948-2.51657825s2.61578947 1.05769231 2.61578947 2.51657825c0 1.49535809-1.21578947 2.55305037-2.61578947 2.55305037-1.4-.0364721-2.61578948-1.05769228-2.61578948-2.55305037m3.90526316 0c0-.76591512-.47894737-1.38594164-1.28947368-1.38594164-.81052632 0-1.28947369.62002652-1.28947369 1.38594164s.47894737 1.38594165 1.28947369 1.38594165c.81052631 0 1.28947368-.62002653 1.28947368-1.38594165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.94736842 9.73806366c0-.43766578.33157898-.72944297.69999998-.72944297.3684211 0 .7.29177719.7.72944297 0 .43766574-.3315789.72944294-.7.72944294-.368421-.0364721-.69999998-.3282493-.69999998-.72944294"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYotpoSeeklogo);
export default __webpack_public_path__ + "static/media/yotpo-seeklogo.4e66a8e3c1e0b7bd0e2ef0f5a338c873.svg";
export { ForwardRef as ReactComponent };